import { render, staticRenderFns } from "./StyleEditTabSampleRequests.vue?vue&type=template&id=d984ab14&"
import script from "./StyleEditTabSampleRequests.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabSampleRequests.vue?vue&type=script&lang=js&"
import style0 from "./StyleEditTabSampleRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports